import BrandStore from "stores/BrandStore"

export function brandSiteURL(brandStore: BrandStore) {
  return brandStore.locStore.currentLocation &&
    brandStore.locStore.currentLocation.siteUrl
    ? brandStore.locStore.currentLocation.siteUrl
    : brandStore.brand.siteUrl
}
